import React from "react";
import { Box, Typography, Button, CircularProgress } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import dayjs from "dayjs";

interface StatusPageHeaderProps {
  lastUpdated: string;
  refreshing: boolean;
  onRefresh: () => void;
}

const StatusPageHeader: React.FC<StatusPageHeaderProps> = ({
  lastUpdated,
  refreshing,
  onRefresh,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        mb: 3,
      }}
    >
      <Box>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 700,
            color: "text.primary",
            mb: 0.5,
            fontSize: "1.75rem",
          }}
        >
          System Status
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: "text.secondary",
            fontSize: "0.875rem",
          }}
        >
          Monitor product health and incidents
        </Typography>
      </Box>

      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          Last updated: {dayjs(lastUpdated).format("MMM D, YYYY h:mm A")}
        </Typography>
        <Button
          variant="outlined"
          startIcon={
            refreshing ? (
              <CircularProgress size={18} color="inherit" />
            ) : (
              <RefreshIcon />
            )
          }
          onClick={onRefresh}
          disabled={refreshing}
          sx={{
            height: 40,
            px: 2,
            fontWeight: 600,
            borderRadius: 2,
            textTransform: "none",
            borderColor: "#0288d1",
            color: "#0288d1",
            "&:hover": {
              borderColor: "#0277bd",
              backgroundColor: "rgba(2, 136, 209, 0.04)",
            },
          }}
        >
          Refresh
        </Button>
      </Box>
    </Box>
  );
};

export default StatusPageHeader;
